import React, { FC, Fragment, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Divider, Tab } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Actions from './actions/actions.component';
import Categories from './categories/categories.component';
import ActionPriceLists from './action-price-lists/action-price-lists.component';
import Groups from './groups/groups.component';
import TenderedActions from './tendered-actions/tendered-actions.component';

const ActionSettings: FC = () => {
    const { t: translate } = useTranslation(['lab-settings']);
    const [tabState, setTabState] = useState('actions');

    const handleTabChange = (_: unknown, newTabState: string) => {
        setTabState(newTabState);
    };

    return (
        <Fragment>
            <TabContext value={tabState}>
                <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
                    <TabList onChange={handleTabChange} indicatorColor="primary" textColor="primary">
                        <Tab label={translate('lab-settings:ACTIONS')} value="actions" />
                        <Tab label={translate('lab-settings:TENDERED_ACTIONS')} value="tendered-actions" />
                        <Tab label={translate('lab-settings:PRICE_LISTS')} value="action-price-lists" />
                        <Tab label={translate('lab-settings:CATEGORIES')} value="categories" />
                        <Tab label={translate('lab-settings:GROUPS')} value="groups" />
                    </TabList>
                </Box>
                <Box mb={3}>
                    <Divider />
                </Box>
                <TabPanel sx={{ padding: 0 }} value="actions">
                    <Actions />
                </TabPanel>
                <TabPanel sx={{ padding: 0 }} value="tendered-actions">
                    <TenderedActions />
                </TabPanel>
                <TabPanel sx={{ padding: 0 }} value="action-price-lists">
                    <ActionPriceLists />
                </TabPanel>
                <TabPanel sx={{ padding: 0 }} value="categories">
                    <Categories />
                </TabPanel>
                <TabPanel sx={{ padding: 0 }} value="groups">
                    <Groups />
                </TabPanel>
            </TabContext>
        </Fragment>
    );
};

export default ActionSettings;
